import {
  Anchor,
  AspectRatio,
  Avatar,
  Badge,
  Box,
  Card,
  Center,
  Container,
  Divider,
  Flex,
  Group,
  Image,
  Overlay,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";

import {
  IconScale,
  IconPhone,
  IconMail,
  IconBrandInstagram,
  IconBrandYoutube,
  IconShieldCheck,
  IconBriefcase,
} from "@tabler/icons-react";

import ProfileImg from "../Images/Profileimg.jpeg";
import { useMediaQuery } from '@mantine/hooks';
import Newnavbar from "../Components/Navbar/Newnavbar";

const About = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');




  return (
    <>
      {/* <Navbar /> */}

      <Box
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* BACKGROUND GLOW */}
        <Box
          style={{
            position: "absolute",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: "rgba(59,130,246,0.15)",
            filter: "blur(120px)",
            top: -100,
            right: -100,
          }}
        />
        <Box
          style={{
            position: "absolute",
            width: 400,
            height: 400,
            borderRadius: "50%",
            background: "rgba(168,85,247,0.15)",
            filter: "blur(120px)",
            bottom: -100,
            left: -100,
          }}
        />
        {/* MAIN CONTENT */}
        <Box
          px={{ base: "md", md: "xl" }}
          py={{ base: "md", md: "lg" }}
          style={{
            position: "relative",
            zIndex: 10,
            paddingBottom: 100,
          }}
        >
          <Newnavbar/>
          <Container size="xl" py="md">
            {/* HERO SECTION */}

            <Paper
              radius="30px"
              p={0}
              mb="xl"
              style={{
                overflow: "hidden",
                background:
                  "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #312e81 100%)",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <Box pos="relative">
                <AspectRatio ratio={16 / 5}>
                  <Image src={ProfileImg} alt="About Banner" />
                </AspectRatio>

                <Overlay
                  gradient="linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.85) 100%)"
                  opacity={1}
                />

                <Box
                  pos="absolute"
                  bottom={25}
                  left={25}
                  style={{ display: isMobile ? 'none' : 'block' }}
                >
                  <Badge
                    size="lg"
                    radius="xl"
                    variant="light"
                    color="yellow"
                    mb="md"
                  >
                    Delhi Based Legal Services
                  </Badge>

                  <Title c="white" fw={800}>
                    About Our Legal Platform
                  </Title>

                  <Text c="white" mt="sm" maw={700}>
                    Helping advocates and legal professionals manage court
                    operations, reminders, legal drafts, filing systems, and
                    day-to-day legal workflows efficiently.
                  </Text>
                </Box>
              </Box>
            </Paper>

            {/* ABOUT CONTENT */}

            <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
              <Card
                radius="30px"
                p="xl"
                style={{
                  background: "rgba(255,255,255,0.04)",
                  backdropFilter: "blur(18px)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <Group mb="md">
                  <ThemeIcon
                    size={50}
                    radius="xl"
                    variant="light"
                    color="indigo"
                  >
                    <IconScale size={28} />
                  </ThemeIcon>

                  <div>
                    <Title order={3} c={'white'}>Who We Are</Title>
                    <Text c="dimmed">
                      Professional Legal Assistance Platform
                    </Text>
                  </div>
                </Group>

                <Text size="md" c="dimmed" lh={1.9}>
                  We are a Delhi-based law firm with more than 7 years of
                  professional experience serving clients across India.
                  <br />
                  <br />
                  Our legal practice includes criminal matters, civil litigation,
                  matrimonial disputes, consumer cases, and advisory services.
                  <br />
                  <br />
                  This platform was specially designed to simplify daily legal
                  practice by providing smart legal tools, alert reminders,
                  e-filing access, court resources, police station details, and
                  legal drafts — all in one place.
                </Text>
              </Card>

              <Card
                radius="30px"
                p="xl"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(59,130,246,0.12), rgba(168,85,247,0.12))",
                  backdropFilter: "blur(18px)",
                  border: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <Title order={3} mb="xl" c={'white'}>
                  Platform Highlights
                </Title>

                <Stack gap="lg">
                  <Group align="flex-start">
                    <ThemeIcon radius="xl" color="green" size={42}>
                      <IconShieldCheck size={22} />
                    </ThemeIcon>

                    <div>
                      <Text fw={700}>Secure & Reliable</Text>
                      <Text size="sm" c="dimmed">
                        Protected access with secure legal workflow management.
                      </Text>
                    </div>
                  </Group>

                  <Group align="flex-start">
                    <ThemeIcon radius="xl" color="blue" size={42}>
                      <IconBriefcase size={22} />
                    </ThemeIcon>

                    <div>
                      <Text fw={700}>Daily Court Practice Tools</Text>
                      <Text size="sm" c="dimmed">
                        Access alerts, legal drafts, FIR links,
                        display boards, and more.
                      </Text>
                    </div>
                  </Group>

                  <Group align="flex-start">
                    <ThemeIcon radius="xl" color="violet" size={42}>
                      <IconScale size={22} />
                    </ThemeIcon>

                    <div>
                      <Text fw={700}>Built For Advocates</Text>
                      <Text size="sm" c="dimmed">
                        Designed specifically for lawyers, legal interns, and law
                        professionals.
                      </Text>
                    </div>
                  </Group>
                </Stack>
              </Card>
            </SimpleGrid>

            {/* TEAM SECTION */}

            <Center mt={60} mb="lg">
              <Title order={2} c={'dimmed'}>Connect With Us</Title>
            </Center>

            <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
              {/* PERSON 1 */}

              <Card
                radius="30px"
                p="xl"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(20px)",
                }}
              >
                <Flex justify="space-between" align="center">
                  <Group>
                    <Avatar
                      size={70}
                      radius="xl"
                      src={ProfileImg}
                    />

                    <div>
                      <Title order={4} c={'dimmed'}>Mr. Abhiraj Yadav</Title>

                      <Badge color="blue" variant="light" mt={4}>
                        Advocate
                      </Badge>
                    </div>
                  </Group>
                </Flex>

                <Divider my="lg" />

                <Stack gap="md">
                  <Group>
                    <ThemeIcon radius="xl" color="green">
                      <IconPhone size={16} />
                    </ThemeIcon>

                    <Text c="dimmed">+91 8570092577</Text>
                  </Group>

                  <Group>
                    <ThemeIcon radius="xl" color="red">
                      <IconMail size={16} />
                    </ThemeIcon>

                    <Text c="dimmed">
                      yhappy848@gmail.com
                    </Text>
                  </Group>

                  <Group>
                    <ThemeIcon radius="xl" color="pink">
                      <IconBrandInstagram size={16} />
                    </ThemeIcon>

                    <Anchor
                      href="https://www.instagram.com/adv_abhiraj_yadav?igsh=MWJsZ3k3eDlvcHVlMw=="
                      target="_blank"
                    >
                      Instagram Profile
                    </Anchor>
                  </Group>

                  <Group>
                    <ThemeIcon radius="xl" color="red">
                      <IconBrandYoutube size={16} />
                    </ThemeIcon>

                    <Anchor
                      href="https://m.youtube.com/@adv-abhiraj-yadav"
                      target="_blank"
                    >
                      YouTube Channel
                    </Anchor>
                  </Group>
                </Stack>
              </Card>

              {/* PERSON 2 */}

              <Card
                radius="30px"
                p="xl"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(20px)",
                }}
              >
                <Flex justify="space-between" align="center">
                  <Group>
                    <Avatar
                      size={70}
                      radius="xl"
                      src={ProfileImg}
                    />

                    <div>
                      <Title order={4} c={'dimmed'}>Mr. Sameer Malik</Title>

                      <Badge color="violet" variant="light" mt={4}>
                        Advocate
                      </Badge>
                    </div>
                  </Group>
                </Flex>

                <Divider my="lg" />

                <Stack gap="md">
                  <Group>
                    <ThemeIcon radius="xl" color="green">
                      <IconPhone size={16} />
                    </ThemeIcon>

                    <Text c="dimmed">+91 9473632645</Text>
                  </Group>

                  <Group>
                    <ThemeIcon radius="xl" color="red">
                      <IconMail size={16} />
                    </ThemeIcon>

                    <Text c="dimmed" size={isMobile ? 'xs' : 'md'}>
                      officialadvocatesameer@gmail.com
                    </Text>
                  </Group>

                  <Group>
                    <ThemeIcon radius="xl" color="pink">
                      <IconBrandInstagram size={16} />
                    </ThemeIcon>

                    <Anchor
                      href="https://www.instagram.com/advocate_sameer_malik?igsh=MWo2aGsxYzlrb2trdg=="
                      target="_blank"
                    >
                      Instagram Profile
                    </Anchor>
                  </Group>
                </Stack>
              </Card>
            </SimpleGrid>
          </Container>
        </Box>
      </Box>


    </>
  );
};

export default About;